import React, { useEffect, useState } from 'react';
import Input from '..';
import { validateEmail } from '../../../utils';
import { postReq } from '../../../utils/api';
import { DOMAIN } from '../../../Constants/base';

export default function EmailInput(props) {
  const { email, setEmail, checkForValidEmail, setCheckForValidEmail, setCurrentStep, isApi, setIsApi, isSignUp } =
    props;

  const [error, setError] = useState('');

  useEffect(() => {
    if (checkForValidEmail) {
      if (validateEmail(email)) {
        setError('');
        setCheckForValidEmail(false);
        handleGenerateOtp();
      } else {
        setError('Please enter a valid email address');
        setCheckForValidEmail(false);
      }
    }
  }, [checkForValidEmail, email]);

  const handleEnter = () => {
    if (validateEmail(email)) {
      setError('');
      handleGenerateOtp();
    } else {
      setError('Please enter a valid email address');
    }
  };

  const handleEmailChange = (e) => {
    setError('');
    setEmail(e.target.value);
  };

  // Generate OTP API
  const handleGenerateOtp = async () => {
    if (isApi) return;
    setIsApi(true);
    let url = `${DOMAIN}/v1/user/v2/login/generate-otp`;
    let payload = {
      email: email,
    };

    if (isSignUp) {
      payload = {
        ...payload,
        newUser: true,
      };
    }

    const otpRes = await postReq({ url, payload });
    const { code, message } = otpRes;
    if (code === 200) {
      setCurrentStep((prev) => prev + 1);
    } else if (code !== 200 && message) {
      setError(message);
    } else if (code !== 200 && !message) {
      setError('Oops! Something went wrong, please contact us!');
    }
    setIsApi(false);
  };

  return (
    <Input
      value={email}
      onChange={handleEmailChange}
      onEnter={handleEnter}
      name="email"
      placeholder="Email Address"
      error={error}
      label="What’s your Email Address?"
    />
  );
}
